module.exports = __webpack_public_path__ + "img/icon_file.f198b8f.png";